module.exports = __webpack_public_path__ + "static/media/nowifi.eab67dc5.svg";